import { FEATURE_KEYS, MODULE_KEYS, OPERATION_IDS } from '../routes/ids.js';
import { getDashboardTableDescriptor } from './table-registry.js';
const tk = (value) => value;
function column(field, fieldType = 'text', overrides = {}) {
    return {
        id: `column.dashboard.recentActivity.${field}`,
        schemaVersion: 1,
        module: MODULE_KEYS.DASHBOARD,
        feature: FEATURE_KEYS.DASHBOARD_VIEW,
        privacyClassification: 'FINANCIAL',
        telemetryId: `dashboard.recentActivity.column.${field}`,
        accessibilityLabelKey: tk(`dashboard.recentActivity.columns.${field}`),
        availability: 'AVAILABLE',
        owner: 'reports-dashboard',
        labelKey: tk(`dashboard.recentActivity.columns.${field}`),
        field,
        fieldType,
        sortable: false,
        filterable: false,
        searchable: false,
        groupable: false,
        hideable: false,
        defaultVisible: true,
        requiredVisible: true,
        resizable: true,
        reorderable: false,
        pinnable: false,
        defaultWidth: field === 'instrumentSymbol' ? 130 : 150,
        minWidth: 90,
        maxWidth: 260,
        align: field === 'quantity' || field === 'totalAmount' ? 'right' : 'left',
        nullDisplayBehavior: 'dash',
        ...overrides,
    };
}
export const DASHBOARD_RECENT_ACTIVITY_TABLE = Object.freeze({
    id: 'table.dashboard.recentActivity',
    schemaVersion: 1,
    module: MODULE_KEYS.DASHBOARD,
    feature: FEATURE_KEYS.DASHBOARD_VIEW,
    privacyClassification: 'FINANCIAL',
    telemetryId: 'dashboard.recentActivity.table',
    accessibilityLabelKey: tk('dashboard.widgets.recentActivity'),
    availability: 'AVAILABLE',
    owner: 'reports-dashboard',
    operationId: OPERATION_IDS.TRANSACTION_LIST,
    titleKey: tk('dashboard.widgets.recentActivity'),
    dataSourceId: 'query.dashboard.recentActivity',
    rowIdField: 'id',
    columns: [
        column('transactionDate', 'datetime', { defaultWidth: 170 }),
        column('transactionType', 'status', { defaultWidth: 130 }),
        column('instrumentSymbol', 'text'),
        column('quantity', 'quantity', { defaultWidth: 120 }),
        column('totalAmount', 'money', { defaultWidth: 140 }),
        column('status', 'status', { defaultWidth: 130 }),
    ],
    pagination: { pageSize: 8, pageSizeOptions: [8] },
    operationMode: 'client',
    serverSidePagination: false,
    serverSideSorting: false,
    serverSideFiltering: false,
    capabilities: {
        sorting: false,
        filtering: false,
        globalSearch: false,
        grouping: false,
        aggregation: false,
        pagination: false,
        selection: false,
        columnVisibility: false,
        columnResizing: true,
        columnReordering: false,
        columnPinning: false,
        savedViews: false,
        export: false,
        refresh: false,
        density: false,
        create: false,
    },
    toolbar: {
        showResultCount: false,
        showGlobalSearch: false,
        showFilterRowToggle: false,
        showColumnChooser: false,
        showDensity: false,
        showRefresh: false,
        showExport: false,
        showCreateAction: false,
    },
});
export function getEffectiveDashboardTableDescriptor(id) {
    if (id === DASHBOARD_RECENT_ACTIVITY_TABLE.id)
        return DASHBOARD_RECENT_ACTIVITY_TABLE;
    return getDashboardTableDescriptor(id);
}
